import { z } from 'zod';
import {
  AuthorizationStates,
  EventSchema,
  EventTypeSchema,
  EventTypes,
  MapType,
} from '../schema/events';
import { DateSchema } from './base';
import { StarterSchema } from './starters';

export type BaseEvent = z.infer<typeof EventSchema>;

export const PlayerEventInfoSchema = EventSchema.omit({
  passcode: true,
  payments: true,
  startTimeOrderingKey: true,
  paidAt: true,
  images: true,
  integrations: true,
}).extend({
  eventType: EventTypeSchema,
  geoJSON: z.object({
    type: z.string(),
    features: z.array(z.any()),
  }),
  starters: z.array(StarterSchema),
  splits: z.array(z.any()),
  shadowTrackIsVisible: z.boolean(),
  updatedAt: DateSchema,
});

export const EventInfoSchema = z.array(PlayerEventInfoSchema);

export type EventInfo = z.infer<typeof EventInfoSchema>;

export const PlayerBaseOptionsSchema = z.object({
  eventId: z.string(),
  name: z.string(),
  slug: z.string().optional(),
  startTime: z.string(),
  endTime: z.string(),
  type: z.enum(EventTypes),
  mapType: z.enum(MapType),
  app: z.boolean(),
  authorization: z.enum(AuthorizationStates),
  baseColor: z.string(),
  largeMode: z.boolean(),
  updatedAt: z.string(),
  createdAt: z.string(),
});

export type PlayerBaseOptions = z.infer<typeof PlayerBaseOptionsSchema>;
